import { render, staticRenderFns } from "./ControleEquipamentosDashboard.vue?vue&type=template&id=171b849c&scoped=true"
import script from "./ControleEquipamentosDashboard.vue?vue&type=script&lang=js"
export * from "./ControleEquipamentosDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b849c",
  null
  
)

export default component.exports